import { useEffect, useState } from 'react';
import { getLootPieceInfo } from 'src/services/lootPieceInfo';
import { NETWORKS } from 'src/base/constants';

export default function useGetLootPieceInfo( networkName = NETWORKS.ETH.name, pieceId, address ) {
	const [pieceInfo, setPieceInfo] = useState( null );

	useEffect( () => {
		async function fetchPieceInfo() {
			const pieceInfo = await getLootPieceInfo( networkName, pieceId );
			setPieceInfo( pieceInfo );
		}
		fetchPieceInfo();
	}, [networkName, pieceId, address]);

	return pieceInfo;
}
